import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-divine-50 via-white to-sacred-50 flex flex-col">
      <Navbar />

      <div className="flex-grow flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="text-6xl text-spiritual-600 mb-4">🕉️</div>
          <h2 className="text-3xl font-bold text-spiritual-700 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            We couldn't find the page you're looking for. It may have been moved or doesn't exist.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-spiritual-600 text-white rounded-lg hover:bg-spiritual-700 transition-colors"
          >
            Return to Home
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default NotFoundPage